const mEditionBillingPaymentMethodsModalDeleteWarning = {
  mEditionBillingPaymentMethodsModalDeleteWarning: {
    buttonPrimary: 'Entendido',
    message: 'Esta pasarela de pago está activa en uno o más productos, para poder eliminarla primero debes desactivar su relación de venta.',
    title: 'ACCIÓN DESHABILITADA'
  }
}
export default mEditionBillingPaymentMethodsModalDeleteWarning
